/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
const selectors = {
    INPUT: 'input,textarea'
};
const observedInputAttributes = ['disabled', 'readonly', 'value', 'placeholder'];
const classes = {
    DISABLED: 'forge-field--disabled',
    READONLY: 'forge-field--readonly',
    INPUT_FOCUSED: 'forge-field__input--focused',
    LEADING: 'forge-field--leading',
    TRAILING: 'forge-field--trailing',
    ADDON_END: 'forge-field--addon-end',
    ADDON_END_CONTAINER: 'forge-field__addon-end-container',
    FOCUSED: 'forge-field--focused',
    LABEL_FOCUSED: 'forge-field__label--focused',
    SHAPE_ROUNDED: 'forge-field--shape-rounded',
    INVALID: 'forge-field--invalid',
    REQUIRED: 'forge-field--required',
    DENSE: 'forge-field--dense',
    ROOMY: 'forge-field--roomy',
    LABEL: 'forge-field--label'
};
const observedAttributes = {
    DENSITY: 'density',
    FLOAT_LABEL_TYPE: 'float-label-type',
    SHAPE: 'shape',
    INVALID: 'invalid',
    REQUIRED: 'required',
    HOST_LABEL_FLOATING: `forge-label-floating`
};
const attributes = Object.assign({}, observedAttributes);
export const FIELD_CONSTANTS = {
    attributes,
    observedAttributes,
    observedInputAttributes,
    selectors,
    classes
};
